import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import getTimelineCmdByEventAndIdThunk from '../store/timelineUpdateCmds/actions/getTimelineCmdByEventAndId';
import {AppState} from '../store/types';
import {TimelineStateData} from '../store/timelineUpdateCmds/types';

/**
 * Return type of the useTimelineData hook
 */
type UseTimelineDataResult = [
  {loading: boolean, data: TimelineStateData, error?: string | boolean},
  {getTimelineCmdByEventAndId: typeof getTimelineCmdByEventAndIdThunk}
]

/**
 * Selects the 'timeline' state and sum it up into a referring object
 */
const timelineUpdatesSelector = (state: AppState) => ({
  loading: state.timeline.isFetching,
  data: state.timeline.data || {updates: []},
  error: state.timeline.didInvalidate ? state.matches.error : false,
});

/**
 * Wraps up the business logic of selecting the 'timeline' state.
 */
const useTimelineData = (): UseTimelineDataResult => {
  const dispatch = useDispatch();
  const state = useSelector(timelineUpdatesSelector);

  const getTimelineCmdByEventAndId = useCallback((eventId: string, commandId?: string) => dispatch(getTimelineCmdByEventAndIdThunk(eventId, commandId)), [dispatch]);

  return [state, {getTimelineCmdByEventAndId}];
};


export default useTimelineData;
